(function(app) {

    app.provider("lineOfBusinessApi",
        [
            function() {
                this.$get = [
                    "crmApiGateway", function(crmApiGateway) {
                        var service = {};

                        this.get = function(lineOfBusinessId) {
                            return crmApiGateway.get("/LineOfBusinesses/" + lineOfBusinessId);
                        };

                        service.getLineOfBusinesses = function() {
                            return crmApiGateway.getArray("/LineOfBusinesses");
                        };

                        service.updateIsActive = function(lineOfBusinessId, lineOfBusiness) {
                            return crmApiGateway.put("/LineOfBussinesses/" + lineOfBusinessId + "/IsActive", lineOfBusiness);
                        };

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line